import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import {Observable} from "rxjs";
import {UserLogoutCB} from "../../Ope/User/UserLogoutCB";
import {PostLoginCB} from "../../Ope/User/PostLoginCB";
import {ExportAllCustomersDevicesCB} from "../../Ope/User/ExportAllCustomersDevicesCB";
import {ChangePasswordCB} from "../../Ope/User/ChangePasswordCB";

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {

  public changePassword(cb: ChangePasswordCB): Observable<any> {
    return this.execOPE(cb);
  }

  public exportAllCustomersDevices(cb: ExportAllCustomersDevicesCB): Observable<any> {
    return this.execOPE(cb);
  }

  public postLogin(cb: PostLoginCB): Observable<any> {
    return this.execOPE(cb);
  }

  public userLogout(cb: UserLogoutCB): Observable<any> {
    return this.execOPE(cb);
  }


}
